const ROLE_CLAIM_URI =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
const NAME_CLAIM_URI =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name";

function asArray(value) {
  if (value == null || value === "") return [];
  return Array.isArray(value) ? value : [value];
}

/**
 * Admin flag comes from ClaimTypes.Role ("role" / long URI) = "Admin"|"User".
 * Do NOT use the custom "Roles" claim (app roles) — key.includes("role") matches it.
 */
export function isAdminFromTokenPayload(tokenPayload) {
  if (!tokenPayload) return false;

  const roleClaim = tokenPayload[ROLE_CLAIM_URI] || tokenPayload.role;
  return asArray(roleClaim).some(
    (r) => r && String(r).toLowerCase() === "admin"
  );
}

export function claimsFromTokenPayload(tokenPayload) {
  return asArray(tokenPayload && tokenPayload.claims);
}

export function userFromTokenPayload(tokenPayload) {
  if (!tokenPayload) return "";
  return tokenPayload[NAME_CLAIM_URI] || tokenPayload.unique_name || "";
}

export function parseJwtPayload(token) {
  if (!token) return null;
  const parts = token.replace(/^Bearer\s+/i, "").split(".");
  if (parts.length < 2) return null;
  return JSON.parse(atob(parts[1]));
}
